<template>
  <div class="temp-container">
    <div class="temp-header flex flex-between">
      <div @click="back" class="btn">
        <span class="hmicon icon-fanhui"></span>
        返回
      </div>
      <div>报表装修模板</div>
      <ul class="flex header-list">
        <li class="btn" @click="save">
          <span class="hmicon icon-baocun"></span>保存
        </li>
      </ul>
    </div>
    <div class="flex">
      <!-- 组件容器 -->
      <div class="component-list">
        <div class="title">基础组件</div>
        <draggable
          class="dragArea list-group flex flex-wrap"
          :list="reportConfigComponents"
          :sort="false"
          :group="{ name: 'component', pull: 'clone', put: false }"
          @change="log"
          :clone="cloneEnd"
        >
          <!-- :group="{ name: 'component', pull: 'clone', put: false }" -->
          <template v-for="(v, i) in reportConfigComponents">
            <div class="list-group-item" v-if="v.type === 'base'" :key="i">
              <span class="hmicon" :class="v.icon"></span>
              <div class="label">{{ v.label }}</div>
            </div>
          </template>
        </draggable>
      </div>
      <!-- 预览容器 -->
      <div class="preview-container">
        <el-scrollbar>
          <div class="preview-wrapper">
            <div class="preview-head">
              <div class="preview-title">{{ title }}</div>
            </div>
            <div class="preview-body">
              <draggable
                class="dragArea preview-list-group"
                :list="previewComponents"
                group="component"
                @change="log"
              >
                <div
                  class="preview-list-group-item"
                  @click="selectPreviewItem(i, v.prop)"
                  :class="{
                    active: activePreviewIndex === i
                  }"
                  v-for="(v, i) in previewComponents"
                  :key="i"
                >
                  <component
                    :is="v.component"
                    ref="singleComponent"
                    @setTableData="setTableData"
                    v-bind="v.prop"
                  ></component>
                  <div class="widget" @click="deleteCurrentComponent(i)">
                    <span class="widget-label">{{ v.label }}</span>
                    <span class="widget-icon hmicon icon-shanchu1"></span>
                  </div>
                </div>
              </draggable>
              <div class="preview-height-tag">
                <span class="preview-height-tag-text">iPhone 8手机高度</span>
              </div>
            </div>
          </div>
        </el-scrollbar>
      </div>
      <!-- 设置项容器 -->
      <div class="options-container">
        <!-- 全局设置 -->
        <div class="page-setting" v-if="showPageSetting">
          <div class="title-text-setting">
            <div class="page-header">
              <div class="title">模块</div>
              <div class="tips">
                <div class="warning">
                  添加当前被授权使用的报表可视化模块，完成自定义的报表可视化页面
                </div>
              </div>
            </div>
            <div
              class="other-setting flex flex-center have-bg-wrapper"
              style="padding-top: 20px"
            >
              <el-button size="small" type="primary" plain @click="addModule"
                >添加要显示的可视化报表模块</el-button
              >
            </div>
          </div>
        </div>
        <!-- 单个组件设置 -->
        <div class="component-setting" v-if="!showPageSetting">
          <!-- 图片广告 -->
          <div
            class="image-ad-setting"
            v-if="currentProp && currentProp.name === 'image-ad-selection'"
          >
            <div class="p20">
              <div class="title">图片广告</div>
              <div class="tips">
                最多添加6个广告，鼠标拖拽调整广告顺序，建议尺寸1500*720像素
                <div class="warning">
                  页面链接也可输入小程序关联的公众号文章地址
                </div>
              </div>
              <div class="item-setting">
                <div>
                  选择模板
                  <span v-if="currentProp.type === '1'">轮播海报</span>
                  <span v-if="currentProp.type === '2'">一行一张</span>
                  <span v-if="currentProp.type === '3'">两列轮播</span>
                </div>
                <el-radio-group
                  v-model="currentProp.type"
                  class="flex"
                  @change="switchImageAdTemp(currentProp.type)"
                >
                  <el-radio label="1">
                    <div
                      class="shape no-swiper"
                      :class="{ active: currentProp.type === '1' }"
                    >
                      <div class="content"></div>
                    </div>
                  </el-radio>
                  <el-radio label="2">
                    <div
                      class="shape swiper"
                      :class="{ active: currentProp.type === '2' }"
                    >
                      <div class="content"></div>
                    </div>
                  </el-radio>
                  <el-radio label="3">
                    <div
                      class="shape double-swiper flex flex-between"
                      :class="{ active: currentProp.type === '3' }"
                    >
                      <div class="content flex"></div>
                      <div class="content flex"></div>
                    </div>
                  </el-radio>
                </el-radio-group>
              </div>
            </div>
            <div class="have-bg-wrapper">
              <div
                class="item-setting image-ad-selection-upload"
                v-if="currentProp.type === '3'"
              >
                <el-radio-group v-model="imgAdSelectionUpLoadType" class="flex">
                  <el-radio label="leftImgList" style="margin: 0">
                    <div
                      class="context flex item-center flex-center"
                      :class="{
                        active: imgAdSelectionUpLoadType === 'leftImgList'
                      }"
                    >
                      <div>宽度375像素</div>
                      <div
                        class="dot flex"
                        :class="{
                          active: imgAdSelectionUpLoadType === 'leftImgList'
                        }"
                      >
                        <div class="point first"></div>
                        <div class="point"></div>
                        <div class="point"></div>
                      </div>
                    </div>
                  </el-radio>
                  <el-radio label="rightImgList" style="margin: 0">
                    <div
                      class="context flex item-center flex-center"
                      :class="{
                        active: imgAdSelectionUpLoadType === 'rightImgList'
                      }"
                    >
                      <div>宽度375像素</div>
                      <div
                        class="dot flex"
                        :class="{
                          active: imgAdSelectionUpLoadType === 'rightImgList'
                        }"
                      >
                        <div class="point first"></div>
                        <div class="point"></div>
                        <div class="point"></div>
                      </div>
                    </div>
                  </el-radio>
                </el-radio-group>
              </div>
              <draggable
                class="tabbar-setting"
                :list="currentProp.imgList"
                v-if="currentProp.type !== '3'"
              >
                <div
                  class="tabbar-setting-item flex"
                  v-for="(v, i) in currentProp.imgList"
                  :key="i"
                >
                  <div class="delete-tab" @click="deleteCurrentImageAd(i)">
                    <span class="hmicon icon-guanbi1"></span>
                  </div>
                  <div
                    class="icon-wrapper"
                    :class="{ 'no-bg': !v.src }"
                    @click="changeImageAd(i)"
                  >
                    <img :src="v.src" class="img" v-if="v.src" alt="图片广告" />
                    <div class="change-icon">
                      {{ v.src ? "更换图片" : "添加图片" }}
                    </div>
                  </div>
                  <div class="flex-1">
                    <div class="flex item-center mb10">
                      <span class="mr10">标题</span>
                      <el-input
                        class="flex-1"
                        v-model="v.text"
                        size="small"
                        maxlength="10"
                        placeholder="建议10个字以内，可不填"
                      ></el-input>
                    </div>
                    <div class="flex item-center" style="padding: 10px 0">
                      <span class="mr10">类型</span>
                      <el-radio-group
                        v-model="v.pageType"
                        class="flex-1"
                        @change="openGoodsSelect(v, i, 'imgList')"
                      >
                        <el-radio label="page">页面</el-radio>
                        <el-radio label="goods">商品</el-radio>
                        <el-radio label="brand">品牌</el-radio>
                      </el-radio-group>
                    </div>
                    <div class="flex item-center" v-if="v.pageType === 'page'">
                      <span class="mr10">链接</span>
                      <el-select
                        class="flex-1"
                        size="small"
                        clearable
                        placeholder="选择表头"
                        v-if="!v.groupGoods.groupId"
                        v-model="v.hrefAddress"
                        @change="selectGroup($event, i, 'imgList')"
                        filterable
                      >
                        <el-option
                          v-for="(item, index) in microShopRouteList"
                          :key="index"
                          :label="item.hrefName"
                          :value="item.hrefAddress"
                        ></el-option>
                      </el-select>
                      <div class="flex item-center" v-if="v.groupGoods.groupId">
                        <span>分组：</span>
                        <el-tag
                          closable
                          @close="handleCloseGroup('imgList', i)"
                          type="success"
                          >{{ v.groupGoods.groupName }}</el-tag
                        >
                      </div>
                    </div>
                    <div
                      class="flex item-center"
                      v-if="v.pageType === 'goods' && v.goodsInfo.wxshopSpuName"
                    >
                      <span class="mr10">商品</span>
                      <el-tag
                        closable
                        @close="handleClose(v, i)"
                        type="success"
                        >{{ v.goodsInfo.wxshopSpuName }}</el-tag
                      >
                    </div>
                    <div
                      class="flex item-center"
                      v-if="
                        v.pageType === 'brand' &&
                          v.brandInfo &&
                          v.brandInfo.brandName
                      "
                    >
                      <span class="mr10">品牌</span>
                      <el-tag
                        closable
                        @close="handleClose(v, i)"
                        type="success"
                        >{{ v.brandInfo.brandName }}</el-tag
                      >
                    </div>
                  </div>
                </div>
              </draggable>
              <draggable
                class="tabbar-setting"
                :list="currentProp.leftImgList"
                v-if="
                  currentProp.type === '3' &&
                    imgAdSelectionUpLoadType === 'leftImgList'
                "
              >
                <div
                  class="tabbar-setting-item flex"
                  v-for="(v, i) in currentProp.leftImgList"
                  :key="i"
                >
                  <div class="delete-tab" @click="deleteCurrentImageAd(i)">
                    <span class="hmicon icon-guanbi1"></span>
                  </div>
                  <div
                    class="icon-wrapper"
                    :class="{ 'no-bg': !v.src }"
                    @click="changeImageAd(i)"
                  >
                    <img :src="v.src" class="img" v-if="v.src" alt="图片广告" />
                    <div class="change-icon">
                      {{ v.src ? "更换图片" : "添加图片" }}
                    </div>
                  </div>
                  <div class="flex-1">
                    <div class="flex item-center mb10">
                      <span class="mr10">标题</span>
                      <el-input
                        class="flex-1"
                        v-model="v.text"
                        size="small"
                        maxlength="10"
                        placeholder="建议10个字以内，可不填"
                      ></el-input>
                    </div>
                    <div class="flex item-center" style="padding: 10px 0">
                      <span class="mr10">类型</span>
                      <el-radio-group
                        v-model="v.pageType"
                        class="flex-1"
                        @change="openGoodsSelect(v, i, 'leftImgList')"
                      >
                        <el-radio label="page">页面</el-radio>
                        <el-radio label="goods">商品</el-radio>
                        <el-radio label="brand">品牌</el-radio>
                      </el-radio-group>
                    </div>
                    <div class="flex item-center" v-if="v.pageType === 'page'">
                      <span class="mr10">链接</span>
                      <el-select
                        class="flex-1"
                        size="small"
                        clearable
                        placeholder="选择表头"
                        v-if="!v.groupGoods.groupId"
                        v-model="v.hrefAddress"
                        @change="selectGroup($event, i, 'leftImgList')"
                        filterable
                      >
                        <el-option
                          v-for="(item, index) in microShopRouteList"
                          :key="index"
                          :label="item.hrefName"
                          :value="item.hrefAddress"
                        ></el-option>
                      </el-select>
                      <div class="flex item-center" v-if="v.groupGoods.groupId">
                        <span>分组：</span>
                        <el-tag
                          closable
                          @close="handleCloseGroup('leftImgList', i)"
                          type="success"
                          >{{ v.groupGoods.groupName }}</el-tag
                        >
                      </div>
                    </div>
                    <div
                      class="flex item-center"
                      v-if="v.pageType === 'goods' && v.goodsInfo.wxshopSpuName"
                    >
                      <span class="mr10">商品</span>
                      <el-tag
                        closable
                        @close="handleClose(v, i)"
                        type="success"
                        >{{ v.goodsInfo.wxshopSpuName }}</el-tag
                      >
                    </div>
                    <div
                      class="flex item-center"
                      v-if="
                        v.pageType === 'brand' &&
                          v.brandInfo &&
                          v.brandInfo.brandName
                      "
                    >
                      <span class="mr10">品牌</span>
                      <el-tag
                        closable
                        @close="handleClose(v, i)"
                        type="success"
                        >{{ v.brandInfo.brandName }}</el-tag
                      >
                    </div>
                  </div>
                </div>
              </draggable>
              <draggable
                class="tabbar-setting"
                :list="currentProp.rightImgList"
                v-if="
                  currentProp.type === '3' &&
                    imgAdSelectionUpLoadType === 'rightImgList'
                "
              >
                <div
                  class="tabbar-setting-item flex"
                  v-for="(v, i) in currentProp.rightImgList"
                  :key="i"
                >
                  <div class="delete-tab" @click="deleteCurrentImageAd(i)">
                    <span class="hmicon icon-guanbi1"></span>
                  </div>
                  <div
                    class="icon-wrapper"
                    :class="{ 'no-bg': !v.src }"
                    @click="changeImageAd(i)"
                  >
                    <img :src="v.src" class="img" v-if="v.src" alt="图片广告" />
                    <div class="change-icon">
                      {{ v.src ? "更换图片" : "添加图片" }}
                    </div>
                  </div>
                  <div class="flex-1">
                    <div class="flex item-center mb10">
                      <span class="mr10">标题</span>
                      <el-input
                        class="flex-1"
                        v-model="v.text"
                        size="small"
                        maxlength="10"
                        placeholder="建议10个字以内，可不填"
                      ></el-input>
                    </div>
                    <div class="flex item-center" style="padding: 10px 0">
                      <span class="mr10">类型</span>
                      <el-radio-group
                        v-model="v.pageType"
                        class="flex-1"
                        @change="openGoodsSelect(v, i, 'rightImgList')"
                      >
                        <el-radio label="page">页面</el-radio>
                        <el-radio label="goods">商品</el-radio>
                        <el-radio label="brand">品牌</el-radio>
                      </el-radio-group>
                    </div>
                    <div class="flex item-center" v-if="v.pageType === 'page'">
                      <span class="mr10">链接</span>
                      <el-select
                        class="flex-1"
                        size="small"
                        clearable
                        placeholder="选择表头"
                        v-if="!v.groupGoods.groupId"
                        v-model="v.hrefAddress"
                        @change="selectGroup($event, i, 'rightImgList')"
                        filterable
                      >
                        <el-option
                          v-for="(item, index) in microShopRouteList"
                          :key="index"
                          :label="item.hrefName"
                          :value="item.hrefAddress"
                        ></el-option>
                      </el-select>
                      <div class="flex item-center" v-if="v.groupGoods.groupId">
                        <span>分组：</span>
                        <el-tag
                          closable
                          @close="handleCloseGroup('rightImgList', i)"
                          type="success"
                          >{{ v.groupGoods.groupName }}</el-tag
                        >
                      </div>
                    </div>
                    <div
                      class="flex item-center"
                      v-if="v.pageType === 'goods' && v.goodsInfo.wxshopSpuName"
                    >
                      <span class="mr10">商品</span>
                      <el-tag
                        closable
                        @close="handleClose(v, i)"
                        type="success"
                        >{{ v.goodsInfo.wxshopSpuName }}</el-tag
                      >
                    </div>
                    <div
                      class="flex item-center"
                      v-if="
                        v.pageType === 'brand' &&
                          v.brandInfo &&
                          v.brandInfo.brandName
                      "
                    >
                      <span class="mr10">品牌</span>
                      <el-tag
                        closable
                        @close="handleClose(v, i)"
                        type="success"
                        >{{ v.brandInfo.brandName }}</el-tag
                      >
                    </div>
                  </div>
                </div>
              </draggable>
              <el-button
                :disabled="
                  (currentProp.type !== '3' &&
                    currentProp.imgList &&
                    currentProp.imgList.length >= 5) ||
                    (currentProp.type === '3' &&
                      currentProp.leftImgList &&
                      currentProp.leftImgList.length >= 5 &&
                      imgAdSelectionUpLoadType === 'leftImgList') ||
                    (currentProp.type === '3' &&
                      currentProp.rightImgList &&
                      currentProp.rightImgList.length >= 5 &&
                      imgAdSelectionUpLoadType === 'rightImgList')
                "
                type="primary"
                plain
                size="small"
                class="w100"
                @click="addImageAd"
                >添加背景图</el-button
              >
            </div>
            <ul class="other-setting p20">
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">图片角度</span>
                  <span class="sub-title temp">
                    {{ !currentProp.borderRadius ? "直角" : "圆角" }}
                  </span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.borderRadius">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-zhijiao"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.borderRadius }"
                      >
                        <span class="hmicon icon-yuanjiao"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <span class="mr20">页面边距</span>
                <div class="flex-1 text-right">
                  <el-slider
                    :min="0"
                    :max="30"
                    size="small"
                    show-input
                    input-size="small"
                    :show-input-controls="false"
                    v-model="currentProp.margin"
                  ></el-slider>
                </div>
              </li>
              <li
                class="flex flex-between item-center"
                v-if="!currentProp.isSwiper"
              >
                <span class="mr20">图片边距</span>
                <div class="flex-1 text-right">
                  <el-slider
                    :min="0"
                    :max="30"
                    size="small"
                    show-input
                    input-size="small"
                    :show-input-controls="false"
                    v-model="currentProp.marginBottom"
                  ></el-slider>
                </div>
              </li>
            </ul>
          </div>
          <!-- 标题文本设置 -->
          <div
            class="title-text-setting"
            v-if="currentProp && currentProp.name === 'title-text'"
          >
            <div class="page-header">
              <div class="title">标题文本</div>
              <div class="tips">
                <div class="warning">
                  页面链接也可输入小程序关联的公众号文章地址
                </div>
              </div>
              <div class="flex item-center mb20">
                <span class="mr10">标题内容</span>
                <el-input
                  class="flex-1"
                  type="text"
                  size="small"
                  placeholder="请输入标题"
                  v-model="currentProp.title"
                ></el-input>
              </div>
              <div class="flex item-center">
                <span class="mr10">描述内容</span>
                <el-input
                  class="flex-1"
                  type="textarea"
                  maxlength="100"
                  size="small"
                  placeholder="请输入描述,最多100字"
                  v-model="currentProp.subTitle"
                ></el-input>
              </div>
            </div>
            <ul class="other-setting">
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">标题粗细</span>
                  <span class="sub-title temp">
                    {{ currentProp.titleBold ? "加粗体" : "常规体" }}
                  </span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.titleBold">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-xi"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.titleBold }"
                      >
                        <span class="hmicon icon-wenzi-cu"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </li>
              <li class="flex flex-between item-center">
                <div>
                  <span class="mr20">描述粗细</span>
                  <span class="sub-title temp">
                    {{ currentProp.subTitleBold ? "加粗体" : "常规体" }}
                  </span>
                </div>
                <div class="item-setting flex flex-end flex-1">
                  <el-radio-group v-model="currentProp.subTitleBold">
                    <el-radio :label="false">
                      <div
                        class="shape blank flex item-center flex-center"
                        :class="{ active: !currentProp.subTitleBold }"
                      >
                        <span class="hmicon icon-wenzi-xi"></span>
                      </div>
                    </el-radio>
                    <el-radio :label="true">
                      <div
                        class="shape line flex item-center flex-center"
                        :class="{ active: currentProp.subTitleBold }"
                      >
                        <span class="hmicon icon-wenzi-cu"></span>
                      </div>
                    </el-radio>
                  </el-radio-group>
                </div>
              </li>
              <li class="flex flex-between">
                <span class="mr20">标题颜色</span>
                <el-color-picker
                  :predefine="predefine"
                  v-model="currentProp.titleColor"
                  size="mini"
                ></el-color-picker>
              </li>
              <li class="flex flex-between">
                <span class="mr20">描述颜色</span>
                <el-color-picker
                  :predefine="predefine"
                  v-model="currentProp.subTitleColor"
                  size="mini"
                ></el-color-picker>
              </li>
              <li class="flex flex-between">
                <span class="mr20">背景颜色</span>
                <el-color-picker
                  :predefine="predefine"
                  v-model="currentProp.backgroundColor"
                  size="mini"
                ></el-color-picker>
              </li>
            </ul>
            <div class="p20">
              <div class="flex flex-between mb20">
                <div>
                  <span>复制</span>
                  <span class="tips">（复制标题到剪贴板）</span>
                </div>

                <el-switch
                  v-model="currentProp.isShowCopyBtn"
                  active-color="#13ce66"
                  :active-value="true"
                  :inactive-value="false"
                ></el-switch>
              </div>
              <div class="flex flex-between mb20">
                <span>查看更多</span>
                <el-switch
                  v-model="currentProp.isShowMore"
                  active-color="#13ce66"
                  :active-value="true"
                  :inactive-value="false"
                ></el-switch>
              </div>
              <div class="flex item-center" style="padding: 10px 0">
                <span class="mr10">链接类型</span>
                <el-radio-group
                  style="border: none"
                  class="flex-1"
                  v-model="currentProp.pageType"
                  @change="openGoodsSelectSingle"
                >
                  <el-radio label="page" style="marginRight: 20px"
                    >页面</el-radio
                  >
                  <el-radio label="goods" style="marginRight: 20px"
                    >商品</el-radio
                  >
                  <el-radio label="brand">品牌</el-radio>
                </el-radio-group>
              </div>
              <div
                class="flex item-center"
                v-if="currentProp.pageType === 'page'"
              >
                <span class="mr10">链接</span>
                <el-select
                  class="flex-1"
                  size="small"
                  clearable
                  v-if="!currentProp.groupGoods.groupId"
                  placeholder="选择表头"
                  v-model="currentProp.hrefAddress"
                  @change="selectGroup"
                  filterable
                >
                  <el-option
                    v-for="(item, i) in microShopRouteList"
                    :key="i"
                    :label="item.hrefName"
                    :value="item.hrefAddress"
                  ></el-option>
                </el-select>
                <div
                  class="flex item-center"
                  v-if="currentProp.groupGoods.groupId"
                >
                  <span>分组：</span>
                  <el-tag closable @close="handleCloseGroup" type="success">
                    {{ currentProp.groupGoods.groupName }}
                  </el-tag>
                </div>
              </div>
              <div
                class="flex item-center"
                v-if="
                  currentProp.pageType === 'goods' &&
                    currentProp.goodsInfo &&
                    currentProp.goodsInfo.wxshopSpuName
                "
              >
                <span class="mr10">商品</span>
                <el-tag closable @close="handleCloseSingle" type="success">
                  {{ currentProp.goodsInfo.wxshopSpuName }}
                </el-tag>
              </div>
              <div
                class="flex item-center"
                v-if="
                  currentProp.pageType === 'brand' &&
                    currentProp.brandInfo &&
                    currentProp.brandInfo.brandName
                "
              >
                <span class="mr10">品牌</span>
                <el-tag closable @close="handleCloseSingle" type="success">
                  {{ currentProp.brandInfo.brandName }}
                </el-tag>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 开启全局设置按钮 -->
      <div
        class="page-setting-btn"
        @click="openPageSetting"
        :class="{ active: showPageSetting }"
      >
        <span class="hmicon icon-yemianshezhi"></span>
        <span>模块设置</span>
      </div>
    </div>
    <my-upload
      field="file"
      @crop-success="cropSuccess"
      @crop-upload-success="cropUploadSuccess"
      @crop-upload-fail="cropUploadFail"
      v-model="show"
      v-if="show"
      noCircle
      noSquare
      :width="uploadWidth"
      :height="uploadHeight"
      :headers="{ 'X-Access-Token': $token }"
      :params="{ fileDir: 'mallDecoration' }"
      :url="$uploadUrl"
      img-format="png"
    ></my-upload>
    <hm-filter-micro-shop-goods
      type="microShop"
      :visible="dialogVisible"
      :radio="isRadio"
      @saveGoods="saveGoods"
      @setLink="setLink"
      @close="dialogVisible = false"
    ></hm-filter-micro-shop-goods>
    <hm-filter-group-goods
      @saveGroupGoods="saveGroupGoods"
      @close="groupGoodsVisible = false"
      :visible="groupGoodsVisible"
    ></hm-filter-group-goods>
    <hm-filter-he-miao-visual-report
      @saveHeMiaoVisualReport="saveHeMiaoVisualReport"
      @close="heMiaoVisualReportVisible = false"
      :visible="heMiaoVisualReportVisible"
    >
    </hm-filter-he-miao-visual-report>
  </div>
</template>

<script>
/* eslint vue/no-unused-components: [0] */
import { reportConfigComponents, predefine } from "@/utils/tempData";
import { arrayUnique2 } from "@/utils/utils";
import myUpload from "vue-image-crop-upload";
import draggable from "vuedraggable";
import HmRichEditor from "@/components/HmRichEditor";
import notice from "@/components/HmMallComponent/notice";
import contactUs from "@/components/HmMallComponent/contactUs";
import dividingLine from "@/components/HmMallComponent/dividingLine";
import richText from "@/components/HmMallComponent/richText";
import titleText from "@/components/HmMallComponent/titleText";
import imageAdSelection from "@/components/HmMallComponent/imageAdSelection";
import imageTextNav from "@/components/HmMallComponent/imageTextNav";
import goodsList from "@/components/HmMallComponent/goodsList";
import cube from "@/components/HmMallComponent/cube";
import reportModules from "@/components/HmMallComponent/reportModules";
import HmFilterMicroShopGoods from "@/components/HmFilterMicroShopGoods";
import HmFilterHeMiaoVisualReport from "@/components/HmFilterHeMiaoVisualReport";
import HmFilterGroupGoods from "@/components/HmFilterGroupGoods";
import barChart from "@/components/charts/barChart";
import lineChart from "@/components/charts/lineChart";
import pieChart from "@/components/charts/pieChart";
import TableChart from "@/components/charts/tableChart";
import html2canvas from "html2canvas";

import { mapGetters } from "vuex";

export default {
  display: "Clone",
  order: 2,
  components: {
    barChart,
    lineChart,
    pieChart,
    TableChart,
    contactUs,
    dividingLine,
    myUpload,
    notice,
    richText,
    HmRichEditor,
    titleText,
    imageAdSelection,
    imageTextNav,
    goodsList,
    cube,
    HmFilterMicroShopGoods,
    draggable,
    HmFilterGroupGoods,
    reportModules,
    HmFilterHeMiaoVisualReport
  },
  data() {
    return {
      integerTableHeader: [],
      reportConfigComponents,
      tableConditions: [],
      tableHeader: [],
      imgAdSelectionUpLoadType: "leftImgList",
      groupGoodsVisible: false,
      heMiaoVisualReportVisible: false,
      avatarUrl:
        "https://imgcdn.hemiao100.com/hemiaoBase/mallDecoration/timg.jpg",
      isRadio: false,
      goodsType: "",
      tabBarList: {
        plusBg:
          "https://imgcdn.hemiao100.com/hemiaoBase/mallDecoration/65a9b379fb66ac3c7b1d6f6e06bb02f.png",
        showAmountSaved: false,
        showTotalSaved: false,
        showVipCard: true,
        showPlusCouponCount: true,
        showCoupon: true
      },
      selectedThead: "",
      selectedConditions: "",
      pageType: "",
      pageModel: "",
      layoutId: "",
      currentImageAd: "",
      uploadType: "",
      uploadWidth: 20,
      uploadHeight: 20,
      currentIndex: "",
      predefine,
      visible: false,
      showPageSetting: true,
      dialogVisible: false,
      show: false,
      id: "",
      title: "可视化报表配置",
      hotWord: "",
      activePreviewIndex: "",
      tableList: [],
      col: [],
      coypColList: [],
      searchList: [],
      tableGroup: [],
      currentProp: {},
      currentTab: "",
      currentTabIconType: "",
      allComponents: [],
      previewComponents: [],
      currentLinkIndex: "",
      currentLinkPropName: "",
      selectCouponVisible: false,
      dropCol: [],
      moduleList: []
    };
  },
  computed: mapGetters(["tempDetails", "microShopRouteList"]),
  watch: {
    tempDetails(val) {
      this.title = val.pageTitle;

      // this.previewComponents = val.previewComponents
    },
    "currentProp.goodShowType": {
      handler(val) {
        if (val) {
          switch (val) {
            case "big":
              this.type = "大图";
              break;
            case "twoColumn":
              this.type = "一行两个";
              break;
            case "scroll":
              this.type = "横向滑动";
              break;
            default:
              break;
          }
        }
      },
      deep: true
    },
    "currentProp.permutation": {
      handler(val) {
        if (val) {
          this.calcCubeList(val);
        }
      },
      deep: true
    },
    "currentProp.type": {
      handler(val) {
        if (val) {
          this.currentProp.url = "";
        }
      },
      deep: true
    },
    "currentProp.isSwiper": {
      handler(val) {
        if (val) {
          this.currentProp.marginBottom = 0;
        }
      },
      deep: true
    }
  },
  created() {
    this.mode = this.$route.query.mode;
    this.id = this.$route.query.id;
    if (this.mode === "edit") {
      this.querySavedComponennts();
    }
  },
  methods: {
    addModule() {
      this.heMiaoVisualReportVisible = true;
    },
    saveHeMiaoVisualReport(data) {
      this.heMiaoVisualReportVisible = false;
      const layoutComponents = JSON.parse(data.layoutComponents);
      layoutComponents.forEach(v => {
        v.prop.configId = data.configId;
      });
      this.previewComponents = this.previewComponents.concat(layoutComponents);
      setTimeout(() => {
        this.recoveryData();
      }, 0);
    },
    setTableData(data) {
      this.currentProp.data = data;
    },
    selectHmtableThead(val, type, mode) {
      const allData = this.searchList.concat(this.tableHeader);
      const row = allData.find(v => v.columnName === val);
      if (row) {
        const copyRow = JSON.parse(JSON.stringify(row));
        this.conditionsFormat(copyRow);
        if (mode === "single") {
          this.currentProp[type] = [copyRow];
        } else {
          this.currentProp[type].push(copyRow);
          this.currentProp[type] = arrayUnique2(
            this.currentProp[type],
            "columnName"
          );
        }
      }
    },
    conditionsFormat(v) {
      if (v.isWhereColumn === "yes") {
        if (v.columnType === "datetime") {
          if (v.queryMode === "range") {
            v.applyDate = [];
          } else {
            v.queryValue = "";
          }
        } else if (v.columnType === "strings") {
          if (v.queryMode === "multiple") {
            v.isSelect = true;
            v.isMultiple = true;
            v.queryListValue = [];
            v.selectList = this.$sysAllDict[v.associatedDictCode];
          } else if (v.queryMode === "single") {
            v.isSelect = true;
            v.isMultiple = false;
            v.queryValue = "";
            v.selectList = this.$sysAllDict[v.associatedDictCode];
          } else {
            v.isSelect = false;
            v.queryValue = "";
          }
        } else if (v.columnType === "integer") {
          if (v.queryMode === "multiple") {
            v.isSelect = true;
            v.isMultiple = true;
            v.queryListValue = [];
            v.selectList = this.$sysAllDict[v.associatedDictCode];
          } else if (v.queryMode === "single") {
            v.isSelect = true;
            v.isMultiple = false;
            v.queryValue = "";
            v.selectList = this.$sysAllDict[v.associatedDictCode];
          } else if (v.queryMode === "range") {
            v.isSelect = false;
            v.queryStartValue = "";
            v.queryEndValue = "";
          } else {
            v.queryValue = "";
          }
        }
      }
    },
    async querySavedComponennts() {
      const { result } = await this.$store.dispatch(
        "queryStoreVisualReportDetails",
        {
          id: this.id
        }
      );
      if (result) {
        this.previewComponents = JSON.parse(result.layoutComponents);
        setTimeout(() => {
          this.recoveryData();
        }, 0);
      }
    },
    deleteTableHeader(i, type) {
      this.currentProp[type].splice(i, 1);
    },
    addCoupon() {
      this.selectCouponVisible = true;
    },
    cloneEnd(prop) {
      return JSON.parse(JSON.stringify(prop));
    },
    log(e) {
      if (e.added) {
        this.activePreviewIndex = e.added.newIndex;
        this.currentProp = {};
        this.currentProp = e.added.element.prop;
        this.recoveryData();
      } else if (e.moved) {
        this.activePreviewIndex = e.moved.newIndex;
        this.recoveryData();
      }
      this.showPageSetting = false;
    },
    recoveryData() {
      // 防止拖拽组件导致异步加载数据消失
      this.previewComponents.map((v, i) => {
        if (v.prop.data && v.prop.data.length) {
          this.$refs.singleComponent[i].initData(v.prop.data);
        }
      });
    },
    saveCoupon(data) {
      this.selectCouponVisible = false;
      this.currentProp.couponList = data;
    },
    deleteCurrentComponent(i) {
      this.previewComponents.splice(i, 1);
      this.openPageSetting();
      setTimeout(() => {
        this.recoveryData();
      }, 0);
    },
    handleCloseGroup(i) {
      this.currentProp.imgList[i].groupGoods = {};
      this.currentProp.imgList[i].hrefAddress = "";
    },
    changeCouponColorType() {
      this.currentProp.couponColor = "";
    },
    saveGroupGoods(row) {
      this.currentProp.imgList[this.currentIndex].groupGoods = row;
      this.groupGoodsVisible = false;
    },
    selectGroup(e, i) {
      if (e === "groupGoods") {
        this.groupGoodsVisible = true;
        this.currentIndex = i;
      }
    },
    setLink(row) {
      if (this.currentLinkIndex !== -1) {
        this.currentProp[this.currentLinkPropName][
          this.currentLinkIndex
        ].goodsInfo = row;
        this.currentProp[this.currentLinkPropName][
          this.currentLinkIndex
        ].hrefAddress = `/pages/product/product?wxshopSpuId=${row.wxshopSpuId}`;
      } else {
        this.currentProp.goodsInfo = row;
        this.currentProp.hrefAddress = `/pages/product/product?wxshopSpuId=${row.wxshopSpuId}`;
      }
      this.dialogVisible = false;
      this.isRadio = false;
    },
    handleClose(v) {
      v.goodsInfo = {};
      v.hrefAddress = "";
      v.pageType = "";
    },
    openGoodsSelect(v, i, propName) {
      if (v.pageType === "goods") {
        this.dialogVisible = true;
        this.isRadio = true;
        this.currentLinkIndex = i;
        this.currentLinkPropName = propName;
      }
      v.goodsInfo = {};
      v.hrefAddress = "";
      v.groupGoods = {};
    },
    switchImageAdTemp(type) {
      if (type === "3") {
        this.imgAdSelectionUpLoadType = "leftImgList";
        if (this.currentProp.imgList.length) {
          this.currentProp.leftImgList = this.currentProp.imgList;
        } else {
          this.currentProp.leftImgList = [];
        }

        if (!this.currentProp.rightImgList) {
          this.currentProp.rightImgList = [];
        }
      } else {
        if (this.currentProp.leftImgList.length) {
          this.currentProp.imgList = this.currentProp.leftImgList;
        }
      }
      this.$forceUpdate();
    },
    openGoodsSelectSingle() {
      if (this.currentProp.pageType === "goods") {
        this.dialogVisible = true;
        this.isRadio = true;
        // 为-1表示设置单个
        this.currentLinkIndex = -1;
      }
      this.currentProp.goodsInfo = {};
      this.currentProp.hrefAddress = "";
    },
    handleCloseSingle() {
      this.currentProp.goodsInfo = {};
      this.currentProp.hrefAddress = "";
      this.currentProp.pageType = "";
    },
    addGoods() {
      this.dialogVisible = true;
      this.isRadio = false;
    },
    saveGoods(data) {
      this.dialogVisible = false;
      this.currentProp.goodsList = this.currentProp.goodsList.filter(
        v => !v.isMock
      );
      this.currentProp.goodsList.push(...data);
    },
    deleteCurrentGoods(i) {
      this.currentProp.goodsList.splice(i, 1);
      if (this.currentProp.goodsList && !this.currentProp.goodsList.length) {
        this.currentProp.goodsList.push({
          spuMainPic:
            "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
          wxshopSpuName: "这里显示商品标题",
          subTitle: "这里显示商品描述，最多显示一行",
          id: 1,
          temp: true,
          isMock: true,
          wxshopPrice: 0,
          markingPrice: 0
        });
      }
    },
    addHotWord() {
      this.currentProp.hotWordList.push({
        word: ""
      });
    },
    setPlaceholder() {
      if (this.currentProp.hotWordList && this.currentProp.hotWordList.length) {
        this.currentProp.placeholder = this.currentProp.hotWordList[0].word;
      }
    },
    async save() {
      const canvas = await html2canvas(
        document.querySelector(".preview-wrapper"),
        {
          useCORS: true,
          backgroundColor: null
        }
      );
      const previewImg = canvas.toDataURL("image/png");
      let params = {
        layoutType: "storeVisualReport",
        layoutComponents: JSON.stringify(this.previewComponents),
        previewImg
      };
      let actionName = "saveStoreVisualReportList";
      if (this.mode === "edit") {
        actionName = "editStoreVisualReport";
        Object.assign(params, {
          id: this.id
        });
      }
      await this.$store.dispatch(actionName, params);
      this.$message({
        type: "success",
        message: "操作成功！"
      });
      this.$router.back(-1);
    },
    back() {
      this.$confirm("退出将不会保存当前装修，确认退出?", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning"
      }).then(() => {
        this.$router.back();
      });
    },
    deleteCardList(i, prop) {
      this.currentProp[prop].splice(i, 1);
    },
    uploadPlusBg(type) {
      this.uploadType = "plusBg";
      this.uploadWidth = 1500;
      this.uploadHeight = 720;
      if (type === "joinGroupBg") {
        this.uploadType = type;
        this.uploadWidth = 690;
        this.uploadHeight = 96;
      }
      this.show = true;
    },
    openPageSetting() {
      this.currentProp = {};
      this.activePreviewIndex = "";
      this.showPageSetting = true;
    },
    selectPreviewItem(i, prop) {
      this.activePreviewIndex = i;
      this.currentProp = {};
      this.currentProp = prop;
      this.showPageSetting = false;
    },
    cropSuccess() {},
    toggleShow() {
      this.show = !this.show;
    },
    // 添加底部导航栏
    addBannnerImg() {
      this.uploadType = "banner";
      this.uploadWidth = 1380;
      this.uploadHeight = 304;
      this.show = true;
    },
    deleteCurrentImageAd(i) {
      this.currentProp.imgList.splice(i, 1);
    },
    calcCubeList(val) {
      let length = this.currentProp.cubeList
        ? this.currentProp.cubeList.length
        : 0;
      let list = JSON.parse(JSON.stringify(this.currentProp.cubeList));
      if (val < length) {
        list = list.slice(0, val);
      } else if (val > length) {
        for (let i = 0; i < val - length; i++) {
          list.push({
            src: "https://imgcdn.hemiao100.com/hemiaoBase9496-2ff0b5c392c8.png",
            url: ""
          });
        }
      }
      this.currentProp.cubeList = list;
    },
    deleteCurrentBanner(i) {
      this.currentProp.imgList.splice(i, 1);
    },
    changeImageAd(i) {
      this.uploadWidth = 690;
      this.uploadHeight = 152;
      this.show = true;
      this.uploadType = "banner";
      this.currentImageAd = i;
    },
    changeCouponFillType() {
      this.currentProp.bg = "";
    },
    addImageAd() {
      if (this.currentProp.type === "3") {
        this.currentProp[this.imgAdSelectionUpLoadType].push({
          src: "https://imgcdn.hemiao100.com/hemiaoBase9496-2ff0b5c392c8.png",
          hrefAddress: "",
          text: "",
          goodsInfo: {},
          groupGoods: {}
        });
      } else {
        this.currentProp.imgList.push({
          src: "https://imgcdn.hemiao100.com/hemiaoBase9496-2ff0b5c392c8.png",
          hrefAddress: "",
          text: "",
          goodsInfo: {},
          groupGoods: {}
        });
      }
      this.$forceUpdate();
    },
    cropUploadSuccess(jsonData) {
      const url = jsonData.result;
      switch (this.uploadType) {
        case "plusBg":
          this.tabBarList.plusBg = url;
          break;
        case "joinGroupBg":
          this.tabBarList.joinGroupBg = url;
          break;
        case "banner":
          this.currentProp.imgList[this.currentImageAd].src = url;
          break;
        default:
          break;
      }
    },
    deleteCurrentTab(i) {
      this.tabBarList.splice(i, i);
    },
    cropUploadFail() {}
  }
};
</script>
<style lang="scss">
.temp-container {
  .el-carousel__indicators {
    display: none;
  }
  .other-setting {
    .radio-wrapper {
      padding: 0 20px;
      margin-bottom: 20px;
      .sub-title {
        margin-bottom: 0 !important;
      }
    }
    .el-radio-group {
      border: 1px solid #ddd;
      border-radius: 5px;
      height: 30px;
      display: flex;
      .el-radio {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .el-radio__label {
        padding-left: 0;
      }
      .el-radio.is-checked {
        background: #ffeaf3;
      }
      .el-radio {
        margin-right: 0;
        width: 48px;
        height: 30px;
        .hmicon {
          font-size: 14px;
        }
      }
    }
  }
}
</style>
<style scoped lang="scss">
.temp-container {
  .component-list {
    background: #fff;
    padding: 20px;
    width: 219px;
    height: 100vh;
    box-sizing: border-box;
    cursor: pointer;
    .title {
      color: #ccc;
      font-size: 16px;
      margin-bottom: 31px;
    }
    .list-group {
      box-sizing: border-box;
    }
    .list-group-item {
      cursor: pointer;
      margin-bottom: 28px;
      width: 50%;
      text-align: center;
      padding: 10px;
      box-sizing: border-box;
      .hmicon {
        font-size: 24px;
      }
      .label {
        margin-top: 16px;
        font-size: 14px;
        color: #666;
      }
    }
  }
  .preview-container {
    position: absolute;
    top: 220px;
    left: 219px;
    right: 360px;
    bottom: 0;
    user-select: none;
  }
  .preview-wrapper {
    position: relative;
    box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.1);
    width: 375px;
    height: 667px;
    margin: 0 auto;
    .preview-head {
      height: 64px;
      width: 375px;
      margin: 0 auto;
      background: url("https://imgcdn.hemiao100.com/hemiaoBase/download.png");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: 50%;
      position: relative;
      .preview-title {
        width: 180px;
        margin: 0 auto;
        height: 34px;
        line-height: 26px;
        text-align: center;
        padding-top: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .preview-body {
      position: relative;
      .preview-list-group {
        height: 603px;
        .preview-list-group-item {
          position: relative;
          box-sizing: border-box;
          cursor: move;
          border: 2px solid transparent;
          min-height: 20px;
          .widget {
            position: absolute;
            top: 0;
            right: -40px;
            width: 34px;
            cursor: pointer;
            .widget-label {
              display: inline-block;
              background-color: #fff;
              width: 80px;
              height: 24px;
              text-align: center;
              line-height: 24px;
              font-size: 12px;
              pointer-events: none;
              box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
            }
            .widget-icon {
              display: none;
            }
            &::before {
              content: "";
              width: 0;
              height: 0;
              border-width: 5px;
              border-style: solid;
              border-color: transparent #fff transparent transparent;
              position: absolute;
              bottom: 7px;
              left: -10px;
            }
          }
          &:hover {
            .widget-icon {
              display: block;
              cursor: pointer;
              box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
              width: 40px;
              height: 28px;
              text-align: center;
              font-size: 16px;
              line-height: 28px;
              background: #fff;
              color: #e71370;
            }
            .widget-label {
              display: none;
              cursor: pointer;
            }
          }
          *:not(.widget-icon) {
            cursor: move !important;
          }
          &:last-child {
            margin-bottom: 50px;
          }
          &.active,
          &.active:hover {
            box-sizing: border-box;
            border: 2px solid #ea5798;
            cursor: move;
          }
          &:hover {
            box-sizing: border-box;
            border: 2px dashed #ea5798;
            cursor: move;
          }
        }

        .contact-us-item {
          position: absolute;
          bottom: 23px;
          width: 100%;
          z-index: 11;
          left: 0;
        }
        .list-group-item {
          transition: all 0.2s linear;
          background-color: #fddfeb !important;
          border-radius: 2px;
          color: #e2005d;
          text-align: center;
          .label {
            margin-top: 10px;
          }
        }
      }
      .preview-height-tag {
        position: absolute;
        left: -130px;
        bottom: 0;
        width: 130px;
        display: -ms-flexbox;
        display: flex;
        color: #a2a2a2;
        border-bottom: 1px solid #dedede;
        .preview-height-tag-text {
          padding-top: 4px;
          font-size: 12px;
        }
      }
    }
  }

  .options-container {
    width: 360px;
    position: absolute;
    top: 56px;
    box-sizing: border-box;
    padding-bottom: 100px;
    right: 0;
    overflow-x: hidden;
    overflow-y: auto;
    bottom: 0;
    background: #fff;
    .p20 {
      padding: 20px;
    }
    .have-bg-wrapper {
      padding: 0 20px 20px;
      background: #fafafa;
    }
    .title {
      color: #2b2b2b;
      font-weight: 500;
      font-size: 18px;
      margin-bottom: 18px;
    }
    .tips {
      margin: 18px 0 20px;
      font-size: 12px;
      color: #777;
    }
    .sub-title {
      color: #2b2b2b;
      margin-bottom: 20px;
    }
    .page-header {
      padding: 20px;
      font-size: 14px;
      border-bottom: 1px solid #eee;
    }
    .page-footer {
      font-size: 14px;
      .sub-title {
        background: #fff;
        padding: 20px;
      }
    }
  }

  .border-bottom {
    border-bottom: 1px solid #eee;
  }

  .page-setting {
    .tabbar-setting .tabbar-setting-item .icon-wrapper {
      img {
        width: 21px;
      }
    }
  }

  .page-setting-btn {
    position: absolute;
    right: 385px;
    top: 100px;
    width: 98px;
    height: 36px;
    text-align: center;
    font-size: 14px;
    background: #fff;
    border-radius: 2px;
    line-height: 36px;
    cursor: pointer;
    user-select: none;
    &.active {
      background: #e2005d;
      color: #fff;
      .hmicon {
        color: #fff;
      }
    }
    .hmicon {
      margin-right: 5px;
    }
  }
  .temp-header {
    height: 56px;
    line-height: 56px;
    background: #e50065;
    color: #fff;
    padding: 0 22px;
    font-size: 16px;
    user-select: none;
    .hmicon {
      color: #fff;
      font-size: 18px;
      margin-right: 10px;
    }
    .btn {
      cursor: pointer;
    }
    .title {
      font-size: 18px;
    }
    .sub-title {
      font-size: 14px;
    }
    .header-list {
      li {
        border-right: 1px solid #fff;
        padding: 0 22px;
      }
      li:last-child {
        padding-right: 0;
        border-right: 0;
      }
    }
  }
  .tabbar-setting {
    background: #fafafa;
    padding: 20px;
    .tabbar-setting-item {
      position: relative;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 8px 0px rgba(226, 226, 226, 1);
      padding: 10px;
      margin-bottom: 10px;
      .delete-tab {
        position: absolute;
        cursor: pointer;
        font-size: 20px;
        right: -12px;
        top: -10px;
        color: #fff;
        width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        background: #bbb;
        border-radius: 50%;
        z-index: 2;
        opacity: 0;
        transition: all 0.2s linear;
      }
      &:hover {
        .delete-tab {
          opacity: 1;
        }
      }
      .icon-wrapper {
        position: relative;
        width: 66px;
        height: 66px;
        line-height: 66px;
        text-align: center;
        border: 1px solid #ddd;
        margin-right: 10px;
        cursor: pointer;
        img {
          max-width: 36px;
        }
        &.no-bg {
          background: #f0f0f0;
        }
        .change-icon {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          color: #fff;
          text-align: center;
          height: 24px;
          line-height: 24px;
          background: rgba(0, 0, 0, 0.8);
        }
      }
    }
  }
  .card-list {
    .card-list-item {
      position: relative;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 8px 0px rgba(226, 226, 226, 1);
      padding: 10px;
      margin-bottom: 10px;

      &:hover {
        .card-item-delete {
          opacity: 1;
        }
      }
      .card-item-delete {
        position: absolute;
        cursor: pointer;
        font-size: 20px;
        right: -12px;
        top: -10px;
        color: #fff;
        width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        background: #bbb;
        border-radius: 50%;
        z-index: 2;
        opacity: 0;
        transition: all 0.2s linear;
      }
    }
  }
}

.info {
  position: relative;
  .white-bg {
    position: absolute;
    top: 0;
    right: 0;
    background: #fff;
    width: 100px;
    height: 31px;
  }
  .white-bg-type {
    position: absolute;
    top: 9px;
    left: 138px;
    background: #fff;
    width: 80px;
    height: 36px;
  }
}

.other-setting {
  font-size: 14px;
  li {
    margin-bottom: 20px;
    div {
      span:first-child {
        display: inline-block;
        width: 80px;
      }
      .sub-title {
        font-weight: bold;
      }
    }
  }
}
.report-bg-wrapper {
  position: relative;
  margin: 0 auto;
  width: 300px;
  padding-top: 20px;
  &.join-bg {
    img {
      min-height: auto;
    }
  }
  img {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    width: 100%;
    min-height: 150px;
  }
  .tip {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    font-size: 14px;
    box-sizing: border-box;
    padding: 10px 0;
    text-align: center;
  }
}

.tabbar {
  position: absolute;
  margin: 0;
  padding: 0;
  left: 0;
  bottom: 0;
  z-index: 31;
  box-sizing: border-box;
  width: 100%;
  height: 49px;
  img {
    display: block;
    width: 100%;
    height: 100%;
  }
}

.img {
  width: 100%;
}

.member-info {
  background: #fff;
  overflow: hidden;
  height: 150px;
  position: relative;
  &.no-card {
    height: auto;
  }
  .member-card {
    position: relative;
    padding: 0 15px;
    button {
      position: absolute;
      top: 10px;
      right: 20px;
      background: #ffc533;
      border: none;
      border-radius: 30px;
      padding: 5px;
      font-size: 12px;
      outline: 0;
    }
    img {
      border-radius: 5px;
    }
  }
  .info {
    padding: 15px 0;
  }
}

.order-list {
  padding: 15px;
  .img {
    border-radius: 3px;
  }
}

.banner-wrapper {
  .img {
    padding: 0 15px;
    width: calc(100% - 30px);
  }
}

.service-list-card {
  background: #fff;
  border-radius: 3px;
  margin: 15px;
  font-size: 14px;
  &::before {
    display: table;
    content: "";
  }
  .title {
    margin: 20px 10px;
    font-size: 16px;
  }
  &.vertical {
    .service-list {
      display: unset;
      .list-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px;
        border-bottom: 1px solid #f5f5f5;
        margin-bottom: 0;
        .icon-wrapper {
          display: flex;
          align-items: center;
        }
        .hmicon {
          font-size: 14px;
        }
        .icon {
          width: 15px;
          height: auto;
          margin-right: 10px;
        }
      }
    }
  }
  .service-list {
    display: flex;
    flex-wrap: wrap;
    .list-item {
      flex-basis: 25%;
      text-align: center;
      font-size: 14px;
      margin-bottom: 20px;
      .icon {
        height: 30px;
        width: auto;
      }
    }
  }
}

.add-navigation {
  padding: 0 20px;
}

.mb50 {
  margin-bottom: 50px;
}

.join-group-wrapper {
  img {
    margin: 15px 15px 0;
    width: calc(100% - 30px);
    display: block;
  }
}

.coupon-setting {
  .item-setting {
    padding: 0 20px 20px;
    .shape {
      height: 28px;
      .content {
        background-color: transparent;
      }
    }
    .style1 {
      .content {
        background-image: url("https://imgcdn.hemiao100.com/decoration/ps51c6e0a88dcb8ee9-c4c9-44bc-9343-b8754a1b26ad.png");
        background-size: 100% 100%;
      }
    }
    .style2 {
      .content {
        background-image: url("https://imgcdn.hemiao100.com/decoration/ps9addd5b82b7a6c1d-c4f4-419f-be3c-2dc65a83e0f6.png");
        background-size: 100% 100%;
      }
    }
  }

  .settings {
    padding: 20px;

    .label {
      width: 80px;
    }

    .settings-item {
      margin-bottom: 20px;
    }
  }

  .icon-wrapper {
    position: relative;
    width: 66px;
    height: 66px;
    line-height: 66px;
    text-align: center;
    border: 1px solid #ddd;
    margin-right: 10px;
    cursor: pointer;
    img {
      width: auto;
    }
    &.no-bg {
      background: #f0f0f0;
    }
    .change-icon {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      color: #fff;
      text-align: center;
      height: 24px;
      line-height: 24px;
      background: rgba(0, 0, 0, 0.8);
    }
  }
}

.image-ad-setting {
  .tabbar-setting {
    .tabbar-setting-item {
      cursor: move;
    }
  }
  .tabbar-setting {
    padding: 0;
  }
  .icon-wrapper {
    img {
      width: 100%;
    }
  }
  .shape.no-swiper,
  .shape.double-swiper,
  .shape.swiper {
    height: 43px;
  }
  .shape {
    &.swiper {
      position: relative;
      &::before {
        content: "\B7\B7\B7";
        position: absolute;
        left: 50%;
        top: 25%;
        -webkit-transform: translate(-50%);
        transform: translate(-50%);
        color: red;
        font-size: 26px;
      }
    }
    &.double-swiper {
      .content {
        position: relative;
        width: 48%;
        &::before {
          content: "\B7\B7\B7";
          position: absolute;
          left: 50%;
          top: 25%;
          -webkit-transform: translate(-50%);
          transform: translate(-50%);
          color: red;
          font-size: 26px;
        }
      }
    }
  }
}

.income {
  img {
    width: 100%;
  }
}

.cumulative-consumption {
  margin-bottom: 5px;
  .total {
    margin-bottom: 5px;
    font-size: 12px;
  }
  .target {
    color: #ad7b30;
  }
  .progress {
    height: 6px;
    background: rgba(0, 0, 0, 0.2);
    border-radius: 30px;
    overflow: hidden;
    .progress-bar {
      background: #474235;
      opacity: 0.9;
      height: 6px;
      border-radius: 30px;
    }
  }
}

.drag-tips {
  box-sizing: border-box;
  border: 2px solid #ea5798;
  padding: 15px;
  font-size: 12px;
}

.shape {
  background: #fff;
  padding: 3px;
  width: 66px;
  height: 18px;
  box-shadow: 0 0 8px 0 #e2e2e2;
  .content {
    background: #ffeaf3;
    height: 100%;
    width: 100%;
  }
  &.active {
    border: 1px solid #e50065;
  }
}

.component-setting {
  font-size: 14px;
  .have-bg-wrapper {
    padding: 20px;
    background: #fafafa;
  }

  .title-text-setting {
    .other-setting {
      padding: 20px;
      border-bottom: 1px solid #eee;
      li:last-child {
        margin-bottom: 0;
      }
    }
  }

  .shape {
    background: #fff;
    padding: 3px;
    width: 66px;
    height: 18px;
    box-shadow: 0px 0px 8px 0px rgba(226, 226, 226, 1);
    .content {
      background: #ffeaf3;
      height: 100%;
      width: 100%;
    }
    &.radius {
      .content {
        border-radius: 30px;
      }
    }
    &.active {
      border: 1px solid #e50065;
    }
    &.blank.active {
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;
    }
    &.line.active {
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
    }

    &.blank,
    &.line {
      width: 30px;
      height: 22px;
      font-size: 14px;
      text-align: center;
      box-shadow: none;
      &.active {
        background: #ffeaf3;
      }
      .el-radio {
        margin-right: 0;
      }
    }
  }

  .cube-setting {
    .shape {
      height: 50px;
      .column {
        background: #ffd4e7;
        border: 1px dotted #ffdfed;
        margin: 0 2px;
        height: 100%;
      }
    }
  }

  .goods-setting {
    .icon-wrapper {
      position: relative;
      width: 66px;
      height: 66px;
      line-height: 66px;
      text-align: center;
      border: 1px solid #ddd;
      margin-right: 10px;
      cursor: pointer;
      .change-icon {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        color: #fff;
        text-align: center;
        height: 24px;
        line-height: 24px;
        background: rgba(0, 0, 0, 0.8);
      }
    }
  }

  .image-ad-setting {
    .tabbar-setting {
      .tabbar-setting-item {
        cursor: move;
      }
    }
    .tabbar-setting {
      padding: 0;
    }
    .icon-wrapper {
      img {
        width: 100%;
      }
    }
    .shape.no-swiper,
    .shape.double-swiper,
    .shape.swiper {
      height: 43px;
    }
    .shape {
      &.swiper {
        position: relative;
        &::before {
          content: "\B7\B7\B7";
          position: absolute;
          left: 50%;
          top: 25%;
          -webkit-transform: translate(-50%);
          transform: translate(-50%);
          color: red;
          font-size: 26px;
        }
      }
      &.double-swiper {
        .content {
          position: relative;
          width: 48%;
          &::before {
            content: "\B7\B7\B7";
            position: absolute;
            left: 50%;
            top: 25%;
            -webkit-transform: translate(-50%);
            transform: translate(-50%);
            color: red;
            font-size: 26px;
          }
        }
      }
    }
  }
  .other-setting {
    li {
      margin-bottom: 20px;
    }
  }

  .coupon-setting {
    .item-setting {
      padding: 0 20px 20px;
      .shape {
        height: 28px;
        .content {
          background-color: transparent;
        }
      }
    }
  }
}
</style>
